module.exports = __webpack_public_path__ + "static/media/achievement-energiser-bunny.211c01a9.svg";